import { __rest } from "tslib";
import { getItem, updateItem, } from '@esri/arcgis-rest-portal';
import { buildAccessProperties } from './build-access-properties';
export async function setPortalItemAccessPermissions({ id, authentication, username, accessChangeset, }) {
    const { properties = {} } = await getItem(id, {
        authentication,
    });
    const _a = properties.telemetry, _b = _a === void 0 ? {} : _a, { arcgis: { access: currentAccessProperties = {} } = {} } = _b, additionalTelemetryProperties = __rest(_b, ["arcgis"]);
    const accessProperties = buildAccessProperties(username, currentAccessProperties, accessChangeset);
    return updateItem({
        item: {
            id,
            properties: Object.assign(Object.assign({}, properties), { telemetry: Object.assign(Object.assign({}, additionalTelemetryProperties), { arcgis: {
                        access: Object.assign({}, accessProperties),
                    } }) }),
        },
        authentication,
    });
}
//# sourceMappingURL=set-portal-item-access-permissions.js.map